<template>
  <v-dialog class="events-filter" v-model="showFilter" max-width="595px">
    <v-card class="events-filter__card">
      <v-card-title class="events-filter__title h3 white lighten-2">
        Filter Options
        <v-spacer />
        <apio-button
          button-type="primary"
          button-size="small"
          class="mr-2"
          @click="clearFilters()"
          >CLEAR FILTERS
          <apio-icon
            class="ml-2"
            size="16"
            name="ui-trash"
            lightModeColour="white"
            darkModeColour="white"
        /></apio-button>
        <apio-button
          button-type="selected"
          button-size="small"
          @click="showFilter = false"
          >Close
          <apio-icon
            class="ml-2"
            size="16"
            name="cross"
            lightModeColour="white"
            darkModeColour="white"
        /></apio-button>
      </v-card-title>
      <div class="events-filter__inner">
        <v-divider></v-divider>

        <div class="events-filter__header p2-extra-bold">
          Available date range
        </div>
        <apio-date-range-picker
          @update="updateDateRange"
          :start-date="eventFilterOptions.selectedFrom"
          :end-date="eventFilterOptions.selectedTo"
        >
        </apio-date-range-picker>
        <div v-if="getDashAllApps" class="events-filter__header p2-extra-bold">
          App
        </div>

        <v-select
          dense
          outlined
          v-model="eventFilterOptions.selectedApp"
          :items="getClientApps"
          placeholder="Select app"
          hide-details="auto"
          item-text="real_name"
          item-value="appID"
          @input="updateSelectedApp"
        >
        </v-select>

        <div class="events-filter__header p2-extra-bold">Interface</div>

        <v-select
          dense
          outlined
          v-model="eventFilterOptions.selectedInterface"
          :items="getInterfacesForApp"
          :placeholder="interfacePlaceholder"
          hide-details="auto"
          item-text="real_name"
          item-value="hash"
          @input="updateSelectedInterface"
        >
        </v-select>

        <div class="events-filter__header p2-extra-bold">Status</div>
        <div class="events-filter__statuses">
          <apio-checkbox
            :value="false"
            :checked="done"
            class="mr-4"
            v-model="eventFilterOptions.selectedStatuses.done"
            @change="updateSelectedStatus('done')"
            ><div slot="checkbox-label">
              <v-chip class="tiny-extra-bold" small label color="success"
                >Success</v-chip
              >
            </div></apio-checkbox
          >
          <apio-checkbox
            :value="false"
            :checked="warning"
            class="mr-4"
            v-model="eventFilterOptions.selectedStatuses.warning"
            @change="updateSelectedStatus('warning')"
            ><div slot="checkbox-label">
              <v-chip class="tiny-extra-bold" small label color="warning"
                >Warning</v-chip
              >
            </div></apio-checkbox
          >
          <apio-checkbox
            :value="true"
            :checked="error"
            class="mr-4"
            v-model="eventFilterOptions.selectedStatuses.error"
            @change="updateSelectedStatus('error')"
            ><div slot="checkbox-label">
              <v-chip class="tiny-extra-bold" small label color="error"
                >Error</v-chip
              >
            </div></apio-checkbox
          >
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { pickBy, keys } from "lodash"; // The _.pickBy() method is used to return a copy of the object that composed of the object properties predicate returns truthy for.

import dayjs from "dayjs";

var utc = require("dayjs/plugin/utc"); // dependent on utc plugin
var timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  props: {
    dialog: {
      default: false,
    },
    selectedApp:  {
    },
    selectedInterface: {
    },
    selectedStatuses: {
    },
    selectedGroup: {
    },
    selectedFrom: {
    },
    selectedTo: {
    },
  },
  data() {
    return {
      filtered: false,
      error: true,
      warning: false,
      done: false,
      eventFilterOptions: {
        selectedFrom: this.$route.query.f ? dayjs(this.$route.query.f * 1000) : this.selectedFrom || dayjs().hour(0).minute(0).second(0).subtract(7, 'days'),
        selectedTo: this.$route.query.t ? dayjs(this.$route.query.t * 1000) : this.selectedTo || dayjs().hour(23).minute(59).second(59),
        selectedApp: this.$route.query.a || this.selectedApp,
        selectedGroup: this.$route.query.g || this.selectedGroup,
        selectedInterface: this.$route.query.i || this.selectedInterface,
        selectedStatuses: {
          done: true,
          warning: true,
          error: true,
        },
        q: "",
      },
      getDashAllGroups: [],
    };
  },
  components: {
    ApioDateRangePicker: () => import("@/components/Misc/DateRangePicker.vue"),
  },
  computed: {
    ...mapState({
      apps: (state) => state.apps.apps,
    }),
    ...mapGetters(["getDashAllApps"]),
    initialFromUnix() {
      const fromDate = dayjs().hour(0).minute(0).second(0).subtract(7, 'days').utc().unix();
      return fromDate;
    },
    initialToUnix() {
      const toDate = dayjs().hour(23).minute(59).second(59).utc().unix();
      return toDate;
    },
    showFilter: {
      set: function () {
        this.$emit("toggleFilter");
      },
      get: function () {
        return this.dialog;
      },
    },
    groupPlaceholder() {
      return this.eventFilterOptions.selectedApp &&
        this.getInterfacesForApp.length === 0
        ? "No groups available"
        : "Select group";
    },
    interfacePlaceholder() {
      return this.eventFilterOptions.selectedApp &&
        this.getInterfacesForApp.length === 0
        ? "No interfaces available"
        : "Select interface";
    },
    getApp() {
      return this.apps.find(
        (app) => app.appID === this.eventFilterOptions.selectedApp
      );
    },
    getClientApps() {
      return this.apps.filter(
        (app) => app.clientHash.startsWith(this.$route.query.c)
      );
    },
    getInterfacesForApp() {
      return this.getApp?.interfaces.filter(intf => intf.icon === 'cogs') || [];
    },
  },
  created() {
    this.$store.dispatch("getApps", {
      c: "*",
      q: "",
    });
  },
  methods: {
    clearFilters() {
      if(!this.$route.query.a) { //do not attempt to clear the app from the filter if it's a query param
        this.eventFilterOptions.selectedApp = "";
      }
      this.eventFilterOptions.selectedGroup = "";
      this.eventFilterOptions.selectedInterface = "";
      this.eventFilterOptions.selectedFrom = "";
      this.eventFilterOptions.selectedFromUnix = "";
      this.eventFilterOptions.selectedTo = "";
      this.eventFilterOptions.selectedToUnix = "";
      this.eventFilterOptions.selectedStatuses = {
        done: true,
        warning: true,
        error: true,
      };
      this.updateEventsFilter();
    },
    updateDateRange(val) {
      val?.startDate.setHours(0, 0, 0, 0);
      val?.endDate.setHours(23, 59, 59, 59);
      this.eventFilterOptions.selectedFrom = val.startDate;
      this.eventFilterOptions.selectedFromUnix = dayjs.tz(val.startDate).utc().unix();
      this.eventFilterOptions.selectedTo = val.endDate;
      this.eventFilterOptions.selectedToUnix = dayjs.tz(val.endDate).utc().unix();
      this.updateEventsFilter();
    },
    updateSelectedStatus(val) {
      this.eventFilterOptions.q = "";
      this.eventFilterOptions.selectedStatuses[val] !=
        this.eventFilterOptions.selectedStatuses[val];
      this.eventFilterOptions.selectedStatuses = {
        error: this.eventFilterOptions.selectedStatuses["error"],
        done: this.eventFilterOptions.selectedStatuses["done"],
        warning: this.eventFilterOptions.selectedStatuses["warning"],
      };
      const filtered = pickBy(this.eventFilterOptions.selectedStatuses);
      this.eventFilterOptions.q = keys(filtered).join(",");
      this.updateEventsFilter();
    },
    updateSelectedApp(val) {
      this.eventFilterOptions.selectedApp = val;
      this.eventFilterOptions.selectedGroup = "";
      this.eventFilterOptions.selectedInterface = "";
      this.updateEventsFilter();
    },
    updateSelectedGroup(val) {
      this.eventFilterOptions.selectedGroup = val;
      this.eventFilterOptions.selectedInterface = "";
      this.updateEventsFilter();
    },
    updateSelectedInterface(val) {
      this.eventFilterOptions.selectedInterface = val;
      this.updateEventsFilter();
    },
    updateSelectedStatuses(val) {
      this.eventFilterOptions.selectedStatuses = val;
      this.updateEventsFilter();
    },
    updateEventsFilter() {
      this.$emit("filterUpdate", this.eventFilterOptions);
    },
  },
};
</script>

<style lang="scss" scoped>
.events-filter {
  height: 600px;
  @media screen and (min-width: 642px) {
    height: 400px;
  }
  &__title {
    display: flex;
    justify-content: space-between;
  }
  &__header {
    color: var(--apio-shade-2);
    margin: 16px 0 8px;
  }
  &__inner {
    padding: 16px;
  }
  &__statuses {
    display: flex;
    align-items: center;
    @media screen and (max-width: 535px) {
      flex-wrap: wrap;
    }
  }
}
</style>
